import React from "react";
import Hero from "./hero";
import Features from "./features";
import Footer from "../footerComponent/footer";
import '../../index.css';

function App() {
  return (
    <div>
      <Hero />
      <Features />
      <Footer />
    </div>
  );
}

export default App;